import React from "react";
import { Helmet as HelmetComponent } from "react-helmet-async";

export const Helmet = (props) => (
  <HelmetComponent {...props} />
);

